<script>
import { Bar } from 'vue-chartjs'
import 'chartjs-plugin-colorschemes';

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}
function getRandomColor() {
  var letters = '0123456789ABCDEF';
  var color = '#';
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}


export default {
  extends: Bar,
  props: ['data'],
  mounted () {
    const dates = this.data.map(d => d.date).filter(onlyUnique);
    const statuses = this.data.map(d => d.pipelineStatus).filter(onlyUnique);
    const colors = statuses.map(getRandomColor);
    const map = {};
    statuses.forEach(status => {
      map[status] = {};
    });
    this.data.forEach(entry => {
      map[entry.pipelineStatus][entry.date] = entry.count;
    });

    const data = {
      labels: dates,
      datasets: statuses.map((status, a) => {
        return {
          label: status,
          data: dates.map(date => {
            return map[status][date] || 0;
          }),
        };
      }),
    };
    const options = {
      scales: {
        yAxes: [{
          stacked: true
        }],
        xAxes: [{
          stacked: true
        }]
      },
      plugins: {
        colorschemes: {
          scheme: 'brewer.Paired12'
        }
      }
    }
    this.renderChart(data, options);
  }
}
</script>
